import React, {useContext} from 'react'
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import StyledSpanCellBold from "components/TableCells/StyledSpanCellBold";
import Options from "./Options";
import FormattedNumberWithCurrency
    from "../../../../../../components/formattedNumberWithCurrencies/formattedNumberWithCurrency";
import {OrderContext} from "../../../../../../contexts/OrderContext";
import {dangerColor, grey200, grey500, orange500, orangeColor} from "../../../../../../assets/jss/main";

export default function Name({lineItem}) {
    const {currentOrganization} = useContext(OrderContext);

    return (
        <>
            <StyledSpanCellBold>{lineItem.name}</StyledSpanCellBold>
            <span><FormattedMessage id={"picking.order.show.table.name.ugs"} /> {lineItem.productSku}</span>
            {(lineItem.metadata && lineItem.metadata['is_special']) ?
                <span><FormattedMessage id={"picking.order.show.table.name.special_description"} /> {lineItem.metadata['description']}</span>
                :
                <span><FormattedMessage id={"picking.order.show.table.name.sku"} /> {lineItem.variationSku}</span>
            }
            {(lineItem.metadata && lineItem.metadata['purchasePrice']) &&
                <span>
                    <FormattedMessage id={'picking.order.show.table.name.purchasePrice'}/>
                    <FormattedNumberWithCurrency
                        value={lineItem.metadata['purchasePrice'] / 100}
                        currency={currentOrganization?.currency}
                    />
                </span>
            }
            {(lineItem.metadata && lineItem.metadata['supplierOrderId']) &&
                <span>
                    <FormattedMessage id={'picking.order.show.table.name.supplierOrderId'}/> {lineItem.metadata['supplierOrderId']}
                </span>
            }
            {(lineItem.variation && lineItem.variation.barcode) && (
                <span>
                    <FormattedMessage id={"picking.order.show.table.name.ean"} /> {lineItem.variation.barcode}
                </span>
            )}
            <Options lineItem={lineItem}/>
            {lineItem.wmsReady ?
                <span style={{'fontSize': '.8em', 'fontWeight': 'bold', 'color': orange500}}>
                    <FormattedMessage id={"picking.order.show.table.name.handledByWms"} />
                </span>
            : (lineItem['customMetaData'] && lineItem['customMetaData']['isSAP'] === true) &&
                <span style={{'fontSize': '.8em', 'fontWeight': 'bold', 'color': orange500}}>
                    <FormattedMessage id={"picking.order.show.table.name.handledBySAP"} />
                </span>
            }
       </>
    );
}

Name.defaultProps = {
    lineItem: {}
};

Name.propTypes = {
    lineItem: PropTypes.shape({
        name: PropTypes.string,
        variation: PropTypes.object,
        productSku: PropTypes.string,
        variationSku: PropTypes.string,
        size: PropTypes.string,
        color: PropTypes.string
    })
};
